/* MadMouse — Smooth page transition for marked links.
   Triggered by clicks on a[data-mm-page-transition].
   Uses the View Transitions API where available (Chrome 111+, Safari 18+) and
   falls back to a CSS fade-out + sessionStorage handoff for fade-in on landing. */
(function () {
  if (typeof document === 'undefined') return;

  var style = document.createElement('style');
  style.textContent =
    'html.mm-page-leaving { pointer-events: none; }' +
    'html.mm-page-leaving body { opacity: 0; transition: opacity 240ms cubic-bezier(.4, 0, .2, 1); }' +
    '@keyframes mm-page-enter { from { opacity: 0; } to { opacity: 1; } }' +
    'html.mm-page-entering body { animation: mm-page-enter 280ms cubic-bezier(.4, 0, .2, 1) both; }' +
    '@media (prefers-reduced-motion: no-preference) {' +
      '::view-transition-old(root) { animation: mm-vt-out 220ms cubic-bezier(.4,0,.2,1) both; }' +
      '::view-transition-new(root) { animation: mm-vt-in  280ms cubic-bezier(.4,0,.2,1) both; }' +
      '@keyframes mm-vt-out { to { opacity: 0; } }' +
      '@keyframes mm-vt-in  { from { opacity: 0; } }' +
    '}';
  document.head.appendChild(style);

  /* Fade-in if we just arrived from a transition click */
  try {
    if (sessionStorage.getItem('mm-transitioning') === '1') {
      sessionStorage.removeItem('mm-transitioning');
      document.documentElement.classList.add('mm-page-entering');
      window.setTimeout(function () {
        document.documentElement.classList.remove('mm-page-entering');
      }, 320);
    }
  } catch (e) { /* sessionStorage may be unavailable in private mode */ }

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[data-mm-page-transition][href]');
    if (!link) return;
    if (e.defaultPrevented) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;

    var href = link.getAttribute('href');
    if (!href) return;
    /* Same-page anchors, mailto, tel, etc. → let default behavior handle */
    if (href.charAt(0) === '#' || /^(mailto:|tel:|javascript:)/i.test(href)) return;
    /* External origins → don't intercept */
    try {
      var url = new URL(href, location.href);
      if (url.origin !== location.origin) return;
      if (url.pathname === location.pathname && url.search === location.search) return; /* same page */
    } catch (err) { return; }

    e.preventDefault();

    if (document.startViewTransition) {
      document.startViewTransition(function () {
        return new Promise(function () {
          window.location.href = href;
        });
      });
      return;
    }

    /* Fallback fade-out + navigate */
    try { sessionStorage.setItem('mm-transitioning', '1'); } catch (e2) {}
    document.documentElement.classList.add('mm-page-leaving');
    window.setTimeout(function () {
      window.location.href = href;
    }, 240);
  });
})();
